module.exports = __webpack_public_path__ + "35a98b7e7e69e76d4a08e09c2f0a3e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/favelas.png
// module id = 437
// module chunks = 0